import { Tabs } from 'antd'
import { FormattedMessage } from 'react-intl'
import React, { useMemo, useState } from 'react'
import { CardBody, CardHeader } from 'reactstrap'
import withCustomization from 'components/platform/hocs/withCustomization'
import { SettingsButton } from 'components/platform/app/Buttons'
import { PageActionButtons } from 'components/platform/Pages/PageActionButtons'
import { CustomizableTabsContext } from 'components/platform/Pages/CustomizableTabsContext'
import useQueryString from 'components/platform/hooks/useQueryString'
import styles from './style.module.scss'

export const TabsCardBody = CardBody

export const HeaderTitle = ({ title, className = ' ' }) => (
  <span style={{ fontSize: 24, fontWeight: 'bold', lineHeight: '32px' }} className={className}>
    {title}
  </span>
)

export const TabsCardHeader = ({
  title,
  note = undefined,
  right = null,
  className = '',
  headerClassName = '',
  append = undefined,
  style = {},
  noteStyle = {},
  icon = undefined,
}) => (
  <CardHeader style={style} className={`${styles.tabHeader} ${className}`}>
    <div className={'flex'} style={{ alignItems: 'center' }}>
      <span style={{ fontSize: '25px' }}>{icon} </span>
      <HeaderTitle title={title} style={{ lineHeight: '19px' }} className={headerClassName} />
      {append && <span className={styles.append}>{append}</span>}
      {note && (
        <div className={styles.note} style={noteStyle}>
          {note}
        </div>
      )}
    </div>
    {right && <div className={styles.tabRight}>{right}</div>}
  </CardHeader>
)
const getRenderTab = (renders, disabledKeys, renderTitles, activeKey) => ({
  title,
  key,
  showDeleteButton = true,
  showSaveButton = true,
  destroyInactive = false,
}) => {
  const tab = renderTitles[key] || <FormattedMessage id={title} />
  return (
    <Tabs.TabPane disabled={disabledKeys.indexOf(key) >= 0} tab={tab} key={key}>
      <PageActionButtons showDeleteButton={showDeleteButton} showSaveButton={showSaveButton} />
      {(activeKey === key || !destroyInactive) && (
        <>{renders[key] || `Error: Render [${key}] missing`}</>
      )}
    </Tabs.TabPane>
  )
}

const TabCards = ({
  renders,
  sortedFields,
  tabBarExtraContent,
  disabledKeys = [],
  renderTitles = {},
}) => {
  const [value, onSetValue] = useQueryString('tab', sortedFields?.[0]?.key)

  const renderTab = useMemo(() => getRenderTab(renders, disabledKeys, renderTitles, value), [
    renders,
    disabledKeys,
    renderTitles,
    value,
  ])

  return (
    <Tabs
      activeKey={value}
      onChange={onSetValue}
      tabBarStyle={{ width: 200 }}
      tabPosition={'left'}
      tabBarExtraContent={tabBarExtraContent}
    >
      {sortedFields.map(renderTab)}
    </Tabs>
  )
}

const CustomizableTabCards = withCustomization({
  identifier: 'key',
  labelKey: 'title',
  prefix: 'tabs',
  modalTitle: 'global.tabs',
})(TabCards)

/**
 * @param  props
 */
export const CustomizableTabs = props => {
  const {
    defaultItems,
    customizationName = null,
    renders,
    editable = false,
    disabledKeys = [],
    renderTitles = {},
  } = props
  const [opened, setOpened] = useState(false)
  const [context] = useState({})
  if (!editable) {
    return (
      <TabCards
        sortedFields={defaultItems}
        renders={renders}
        disabledKeys={disabledKeys}
        renderTitles={renderTitles}
      />
    )
  }

  // todo: context da finire
  return (
    <CustomizableTabsContext.Provider value={context}>
      <CustomizableTabCards
        tabBarExtraContent={{
          left: editable ? (
            <SettingsButton
              className={'mb-3'}
              onClick={() => setOpened(true)}
              labelKey={'global.customize_tabs'}
            />
          ) : (
            <div style={{ height: 55 }} />
          ),
        }}
        renders={renders}
        onCustomizationClose={() => setOpened(false)}
        customizationOpened={opened}
        customizationName={customizationName}
        definitions={defaultItems}
        disabledKeys={disabledKeys}
        renderTitles={renderTitles}
      />
    </CustomizableTabsContext.Provider>
  )
}
